import React from "react";
import "./Login.css";
import { Button } from "@material-ui/core";
import { auth, googleAuthProvider } from "../../firebase";
import { useStateValue } from "../../StateProvider";
import { actionTypes } from "../../reducer";

function Login() {
  const [{}, dispatch] = useStateValue();

  const signIn = () => {
    auth
      .signInWithPopup(googleAuthProvider)
      .then((result) => {
        //console.log("result: ", result);
        dispatch({
          type: actionTypes.SET_USER,
          user: result.user,
        });
      })
      .catch((error) => {
        alert(error.message);
      });
  };
  return (
    <div className="login">
      <div className="login__container">
        <img
          src="https://seeklogo.com/images/W/whatsapp-icon-logo-6E793ACECD-seeklogo.com.png"
          alt="whatsapp icon"
        />
        <h1>Sign in to WhatsApp</h1>
        <p>
          <a href="https://github.com/deepakkum21">GitHub</a>
        </p>
        <Button onClick={signIn}>Sign In with Google</Button>
      </div>
    </div>
  );
}

export default Login;
